import { forwardRef } from 'react';
import { Paper, Table, TableContainer } from '@mui/material';
import { simpleTableDefaultStyle } from './simpleTableDefaultStyle';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { useInterstateTheme } from '../../InterstateThemeProvider';

/** Compact elements that show attributes or action  */
import { jsx as _jsx } from "react/jsx-runtime";
export const SimpleTable = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    bordered = false,
    hover = true,
    striped = false,
    children,
    sx,
    id,
    dataDensity = 'small',
    background = 'white',
    className,
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  const tableContainerStyle = mergeSxStyle(simpleTableDefaultStyle(theme, bordered, hover, striped), sx);
  return /*#__PURE__*/_jsx(TableContainer, {
    component: Paper,
    sx: tableContainerStyle,
    ref: ref,
    children: /*#__PURE__*/_jsx(Table, {
      className: `interstate-${dataDensity} interstate-${background} ${className}`,
      size: "small",
      id: id,
      "data-testid": rest['data-testid'],
      children: children
    })
  });
});
SimpleTable.displayName = 'SimpleTable';